/* BANDO API CALL */

export const POST_BANDI_CSV_EXPORT = 'POST_BANDI_CSV_EXPORT';

export function bandiCsvExport(query = {}) {
  return {
    type: POST_BANDI_CSV_EXPORT,
    request: {
      op: 'post',
      path: `/@export-bandi-csv`,
      data: query,
    },
  };
}
